<sh-spinner
  *ngIf="!!(endpoint.lastSuccessfulData$ | async) === false; else notLoading"
></sh-spinner>

<ng-template #notLoading>
  <div
    *ngIf="data$ | async; let data"
    id="dataSourceStateCardWebAppContainer"
    [attr.flash]="(refreshed$ | async)?.same === false || null"
    class="container"
  >
    <sh-text size="body-1" color="secondary" style="font-weight: bold">
      {{ title | translate }}
    </sh-text>

    <div class="display-text">
      <div class="data-state">
        <sh-text size="body-2" color="secondary"> Last Update: </sh-text>
        <sh-text size="body-2" color="primary">
          {{ data.lastRefreshDateTime | timeFromNow: 'unknown' }}
        </sh-text>
      </div>
    </div>
    <div class="display-text" *ngIf="isOutdated$ | async">
      <sh-icon
        style="display: inline-block"
        icon="warning"
        size="s"
        tabindex="-1"
      ></sh-icon>
      <div style="margin-left: 4px; float: left; width: 70%">
        <sh-text size="body-2" color="primary">{{
          'label.lastDataSourceRefresh.warningMessage' | translate
        }}</sh-text>
      </div>
    </div>
  </div>
</ng-template>
